import { UserLabelModel, UserLabelFormState } from '@/types';
import BaseService from '@/services/api/BaseService';

class UserLabelService extends BaseService<UserLabelModel | UserLabelFormState> {}

export default new UserLabelService('user-labels');
